module.exports = __webpack_public_path__ + "img/p5-2-1.99c857ec.png";